export default __webpack_public_path__ + "static/media/intro-2.0d5302d2.png";